<template>
  <myDialog :isDialog="isShowXx" title="消息" width="900px" :isFooter="false"  @handleClose="$emit('drawerClose')">
    <template slot="content">
      <div class="msgBox">
        <div class="messageList" v-if="messageList.length >= 1">
          <div class="messageItem" v-for="(item,index) in messageList" :key="index">
            <img src="@/assets/images/gzq/xx-icon.png" alt="">
            <div class="itemRight">
              <span>{{ item.content }}</span>
                <span class="btn" v-if="item.state == 0" @click="handleRead(item)">标记已读</span>
            </div>
          </div>
        </div>
        <div class="fillBtn" @click="getAllRead" v-if="count != 0">
          <img src="@/assets/images/gzq/home/qbyd1.png" alt="">
          <span>全部已读</span>
        </div>
        <div class="noMore" v-if="messageList.length == 0">
          <img src="@/assets/images/gzq/zwsj.png" alt="">
          <span>暂无数据</span>
        </div>
      </div>
    </template>
  </myDialog>
</template>

<script>
import {noReadCountMy,listMy,setRead,setAllRead} from "@/api/home/index";
export default {
  props:{
    isShowXx:{
      type:Boolean,
      default:false,
    },
    rowData:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {
      messageList:[],
      count:0
    }
  },
  created(){
    if(this.rowData){
      // this.getDeatil()
    }
  },
  mounted() {
    this.getNoticeList()
    this.getNum()
  },
  methods: {
    // 获取未读消息数量
    getNum(){
      noReadCountMy({}).then(res=>{
        if(res && res.code == 200){
          this.count = res.data.count
        }
      })
    },
    // 获取消息列表
    getNoticeList(){
      listMy({state:0}).then(res=>{
        if(res && res.code == 200){
          this.messageList = res.data
        }
      })
    },
    // 全部已读
    getAllRead(){
      this.$confirm('是否确认全部已读消息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setAllRead({}).then(res=>{
          if(res && res.code && res.data){
            this.getNoticeList()
            this.getNum()
            this.$emit('changeReadXx')
            this.$message.success('全部已读成功!');
          }
        })

      }).catch(() => {
        this.$message.info('已取消!');
      });
    },
    // 点击已读
    handleRead(item){
      this.$confirm('是否确认已读该消息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setRead({id:item.id}).then(res=>{
          if(res && res.code && res.data){
            this.getNoticeList()
            this.$emit('changeReadXx')
            this.$message.success('已读成功!');
          }
        })
      }).catch(() => {
        this.$message.info('已取消!');
      });
    },
    submitForm(){
      this.$emit('drawerClose')
    },

    successAddChange(e) {
      this.$emit('drawerClose')
      this.$message.success('操作成功！')
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog{
  height: 600px !important;
}
/deep/.el-dialog__body{

  padding: 40px 56px !important;
  padding-bottom: 36px;
  overflow: scroll !important;
}
.msgBox{
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
}
.messageList{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .messageItem{
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 14px;
    width: 100%;
    >img{
      width: 40px ;
      height: 40px;
    }
    .itemRight{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 16px;
      padding-top: 10px;
      padding-bottom: 16px;
      border-bottom: 1px solid #EDF0F2;
      flex: 1;
      .title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 10px;
        .bt{
          color: #1c1c1c;
          font-family: "Alibaba PuHuiTi 3.0";
          font-weight: 400;
          font-size: 14px;
        }
        .time{
          color: #464d5a;
          font-family: "Alibaba PuHuiTi 3.0";
          font-weight: 400;
          font-size: 12px;
        }
      }
      >span{
        color: #464d5a;
        font-family: "Alibaba PuHuiTi 3.0";
        font-weight: 400;
        font-size: 12px;
      }
      .btn{
        padding: 3.5px 12px;
        border-radius: 53px;
        background: #ff49581a;
        text-align: right;
        color: #ff4958;
        font-family: "Alibaba PuHuiTi 3.0";
        font-weight: 400;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }

}
.noMore{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
  >img{
    width: 200px;
    height: 200px;
  }
  >span{
    padding-top: 16px;
    letter-spacing: 4px;
    color: #212223;
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: bold;
    font-size: 14px;
  }
}
.fillBtn{
  padding: 0px 12px;
  border-radius: 53px;
  background: #1e6fff1a;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 40px;
  >img{
    width: 16px;
    height: 16px;
  }
  >span{
    color: #1e6fff;
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 14px;
    padding-left: 8px;
  }
}
/* 修改垂直滚动条 */
/deep/::-webkit-scrollbar {
  width: 13px; /* 修改宽度 */
}
</style>
